const NotFound = (): JSX.Element => {
  return (
    <div className="notfound">
      <h1>404</h1>
      <p>This page took a path that doesn&apos;t exist.</p>
      <a className="btn btn-primary" href="/">
        Back to safety
      </a>
    </div>
  );
};

export default NotFound;
